import Vue from 'vue'

const elemCart = document.getElementById('cart')
if (elemCart) {
  import(/* webpackChunkName: "assets/jsc/cart" */ './lazy')
    .then(CartPage => {

    })
}

